import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    common: {
      black: "rgba(0, 0, 0, 1)",
      white: "rgba(255, 255, 255, 1)",
    },
    background: {
      paper: "rgba(255, 255, 255, 1)",
      default: "rgba(241, 243, 246, 1)",
    },
    primary: {
      light: "#818cf8",
      main: "#4f46e5",
      dark: "#4338ca",
      default: "#fff",
      contrastText: "#fff",
    },
    secondary: {
      light: "#a78bfa",
      main: "#7c3aed",
      dark: "#6d28d9",
      default: "#fff",
      contrastText: "#fff",
    },
    success: { main: "#16a34a", contrastText: "#fff" },
    warning: { main: "#f59e0b", contrastText: "#fff" },
    error: {
      light: "#f87171",
      main: "#dc2626",
      dark: "#b91c1c",
      contrastText: "#fff",
    },
    text: {
      primary: "#1e1b4b",
      error: "#dc2626",
      secondary: "#6b7385",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)",
      contrastText: "#fff",
    },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: ["Montserrat", "Segoe UI", "Roboto", "sans-serif"].join(","),
    allVariants: { color: "#1e1b4b" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 700, borderRadius: 12 },
        containedPrimary: {
          background: "linear-gradient(90deg, #4f46e5, #7c3aed)",
          color: "#fff",
          boxShadow: "0 6px 16px rgba(79, 70, 229, 0.3)",
        },
      },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 700 } } },
    MuiTab: { styleOverrides: { root: { textTransform: "none", fontWeight: 700 } } },
  },
});
export default theme;
